import React from 'react';
import { Redirect } from 'react-router-dom';

const ArchivesPageComponent = React.memo(() => <Redirect to="/portfolio" />);

ArchivesPageComponent.displayName = 'ArchivesPageComponent';

export default ArchivesPageComponent;
